module.exports = __webpack_public_path__ + "files/38869d38d84b531c6adc9d317f05bfa2.png";